<template>
  <v-container v-if="!loading" class="pt-0">
    <v-row wrap>
      <v-col cols="6" class="py-1">
        <DisplayField label="Veh 1" :value="coverageInfo.vehicleDescription0" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Veh 2" :value="coverageInfo.vehicleDescription1" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Veh 3" :value="coverageInfo.vehicleDescription2" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Veh 4" :value="coverageInfo.vehicleDescription3" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Towing" :value="towing" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Rental" :value="rental" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Lockout" :value="lockout" />
      </v-col>
      <v-col cols="6" class="py-1">
        <DisplayField label="Premium" :value="formattedPremium" />
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
</style>

<script>
import { mapActions } from 'vuex';
import displayFormatterService from '@/services/shared/displayFormatterService.js';
import apiService from '@/services/shared/agentPortalApiService.js';
import DisplayField from '@/components/Shared/DisplayField.vue';

export default {
  name: 'HomeCoverages',
  components: { DisplayField },
  props: {
    lob: {
      type: Boolean,
      required: false
    },
    policy: {
      type: Boolean,
      required: false
    }
  },
  data: function () {
    return {
      loading: true,
      coverageInfo: null
    };
  },
  computed: {
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    formattedPremium: function () {
      if ((this.coverageInfo || null) === null) {
        return 0;
      }
      return displayFormatterService.formatCurrency(this.coverageInfo.currentPremium);
    },
    towing: function () {
      if ((this.coverageInfo || null) === null) {
        return '';
      }
      return this.formatPolicyCompanySetupStrings(this.coverageInfo.towing);
    },
    rental: function () {
      if ((this.coverageInfo || null) === null) {
        return '';
      }
      return this.formatPolicyCompanySetupStrings(this.coverageInfo.rental);
    },
    lockout: function () {
      if ((this.coverageInfo || null) === null) {
        return '';
      }
      return this.formatPolicyCompanySetupStrings(this.coverageInfo.lockout);
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getMoProCoverages(this.clientId, this.policyOrderNumber);
    if (rs.code === 0) {
      if (rs.data.length === 0) this.coverageInfo = {};

      this.coverageInfo = rs.data[0];
    } else {
      this.error = true;
      this.setError(rs.message);
    }

    this.loading = false;
  },
  methods: {
    ...mapActions(['setError']),
    formatPolicyCompanySetupStrings: function (str) {
      return str.length === 0 ? 'None' : str;
    }
  }
};
</script>
